import React, { useState, useRef } from 'react';
import classnames from 'classnames';
import { string, number, func, bool } from 'prop-types';
import RCSlider from 'rc-slider';
import './Slider.scss';
Slider.propTypes = {
  setSliderValue: func,
  sliderValue: number,
  className: string,
  defaultValue: number,
  min: number,
  max: number,
  isPercent: bool
};

const handleStyle = { border: '1px solid #c0c0bf', height: '20px', width: '20px' };
const railStyle = { height: '10px' };

export default function Slider(props) {
  const { setSliderValue, sliderValue, className, defaultValue, min, max, isPercent } = props;

  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(sliderValue);
  const inputRef = useRef(null);

  function startEditing() {
    setInputValue(sliderValue);
    setIsEditing(true);
  }

  function endEditing(e) {
    // Below logic just binds between max and min values
    let newInpValue = inputValue > max ? max : inputValue < min ? min : inputValue;
    if (inputValue) {
      setSliderValue(Math.round(newInpValue * 1e2) / 1e2);
    } else if (inputValue === null) {
      setSliderValue(0);
    }
    setIsEditing(false);
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter' || e.key === 'Tab') endEditing(e);
  }

  function handleOnChange(e) {
    let targetValue = parseFloat(e.target.value);
    if (!isNaN(targetValue)) {
      setInputValue(targetValue);
    } else if (e.target.value === '') {
      setInputValue(null);
    }
  }

  function loseFocus() {
    inputRef?.current?.blur();
  }

  return (
    <div className={classnames(className, 'slider-input__container')}>
      <RCSlider
        defaultValue={defaultValue}
        handleStyle={handleStyle}
        max={max}
        min={min}
        onBeforeChange={loseFocus}
        onAfterChange={setSliderValue}
        onChange={setSliderValue}
        railStyle={railStyle}
        value={sliderValue}
      />
      {!isEditing ? (
        <div className="slider-value" onClick={startEditing}>
          {sliderValue}
          {isPercent && '%'}
        </div>
      ) : (
        <input
          ref={inputRef}
          autoFocus
          value={inputValue}
          defaultValue={sliderValue}
          className={classnames('slider__text-box')}
          onKeyDown={handleKeyDown}
          onBlur={endEditing}
          onChange={handleOnChange}
          step={0.01}
          min={min}
          max={max}
          type="number"
        />
      )}
    </div>
  );
}
